import React from 'react';
import { ResultsPage } from '../../evaluation/pages/ResultsPage';

export const AttemptDetailsPage: React.FC = () => {
  return <ResultsPage />;
};
